'use client';

import { cn } from '@/lib/utils';
import MarketSection from './MarketSection';
import useWorldCupHalftime from '../../hooks/use-world-cup-halftime';
import { buildColumns, buildMarketSection } from './marketTableUtils';

export interface WorldCupDataTableProps {
  eventSlug: string;
  className?: string;
}

export default function HalftimePanel({ eventSlug, className }: WorldCupDataTableProps) {
  const { halftime } = useWorldCupHalftime({ eventSlug });
  const columns = buildColumns();
  const section = halftime
    ? buildMarketSection('Halftime Result', halftime, {
        icon_name: 'winner',
        icon_class_name: 'text-[#F5BA80]',
      })
    : null;

  return (
    <section
      className={cn('w-full text-white', className)}
      style={{ fontFamily: "'SF Pro', -apple-system, BlinkMacSystemFont, sans-serif" }}
    >
      {section && (
        <div className="space-y-2 overflow-x-auto pb-1">
          <div className="min-w-180 space-y-2">
            <MarketSection section={section} columns={columns} />
          </div>
        </div>
      )}
    </section>
  );
}
